import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "ui-stats-item",
	templateUrl: "./stats-item.component.html",
	styleUrls: ["./stats-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class StatsItemComponent {}
